module.exports = __webpack_public_path__ + "media/unipod/preparation_for_dispatch_1-94f76e67.jpg";